import * as React from "react";
import styles from './LocationProfile.module.css';

interface LocationProfileProps {
  prefix: string;
}

const LocationProfile: React.FC<LocationProfileProps> = ({ prefix }) => {
  return (
    <div className={styles.locationContainer}>
      <span className={styles.locationText}>{prefix}</span>
    </div>
  );
};

export default LocationProfile;